var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 0.666626H2.33325C1.80282 0.666626 1.29411 0.87734 0.919038 1.25241C0.543966 1.62749 0.333252 2.13619 0.333252 2.66663V9.33329C0.333252 9.86373 0.543966 10.3724 0.919038 10.7475C1.29411 11.1226 1.80282 11.3333 2.33325 11.3333H11.6666C12.197 11.3333 12.7057 11.1226 13.0808 10.7475C13.4559 10.3724 13.6666 9.86373 13.6666 9.33329V2.66663C13.6666 2.13619 13.4559 1.62749 13.0808 1.25241C12.7057 0.87734 12.197 0.666626 11.6666 0.666626ZM11.2199 1.99996L6.99992 5.16663L2.77992 1.99996H11.2199ZM11.6666 9.99996H2.33325C2.15644 9.99996 1.98687 9.92972 1.86185 9.8047C1.73682 9.67967 1.66659 9.5101 1.66659 9.33329V2.83329L6.59992 6.53329C6.71532 6.61984 6.85567 6.66663 6.99992 6.66663C7.14417 6.66663 7.28452 6.61984 7.39992 6.53329L12.3333 2.83329V9.33329C12.3333 9.5101 12.263 9.67967 12.138 9.8047C12.013 9.92972 11.8434 9.99996 11.6666 9.99996Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2877ed4a7e4450f2c066b911a5a25e81.svg";
export { ForwardRef as ReactComponent };